import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import LineItem from './LineItem'

import './Cart.css'

class Cart extends Component {
  render() {
    const line_items = this.props.checkout.lineItems.map((line_item) => {
      return (
        <LineItem
          updateQuantityInCart={this.props.updateQuantityInCart}
          removeLineItemInCart={this.props.removeLineItemInCart}
          key={line_item.id}
          line_item={line_item}
        />
      );
    });

    return (
      <div>
        <div className="cart-status" onClick={this.props.handleCartToggle}>
          <span>{this.props.checkout.lineItemCount}</span>
          <span className="cart-toggle" /></div>
        <div className={'cart'+(this.props.isCartOpen ? ' open' : '')}>

          <div>
            <header>
              <h2>Ostoskorisi</h2>
              <span className="close" onClick={this.props.handleCartToggle} />
            </header>

            {line_items.length < 1 && <div>Ostoskorisi on tyhjä</div>}

            {line_items.length>0 &&
              <div className="products">
                {line_items}
              </div>
            }
            
            {(line_items.length>0 && this.props.checkout.subtotal) &&
              <footer>
                Loppusumma <span>{this.props.checkout.subtotal.replace('.',',') + ' €'}</span>
              </footer>
            }
            
            {line_items.length>0 && <a href={this.props.checkout.checkoutUrl} className="btn" target="_blank" rel="noopener noreferrer">Siirry maksamaan</a>}

          </div>
          
        </div>
      </div>
    )
  }
}

export default injectIntl(Cart);


// WEBPACK FOOTER //
// ./src/components/Shopify/Cart.js